import { useFindTypeKeys } from "~/gen/api/hooks"
import { MappingTypeNames } from "~/pages/Admin/Mapping/types"

export const useFindTypeKeysQuery = (type: MappingTypeNames) =>
  useFindTypeKeys({ type })
